import { Box, BoxProps } from "@chakra-ui/react";

export function Sparkle({ ...props }: BoxProps) {
  return (
    <Box {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.55469 9.94994C6.49219 9.70769 6.36593 9.48662 6.18903 9.30972C6.01213 9.13282 5.79106 9.00656 5.54881 8.94406L1.25443 7.83669C1.18116 7.8159 1.11668 7.77177 1.07076 7.71101C1.02484 7.65024 1 7.57616 1 7.5C1 7.42384 1.02484 7.34976 1.07076 7.28899C1.11668 7.22823 1.18116 7.1841 1.25443 7.16331L5.54881 6.05524C5.79097 5.9928 6.01199 5.86664 6.18888 5.68987C6.36577 5.5131 6.49208 5.29218 6.55469 5.05006L7.66206 0.755668C7.68264 0.682113 7.72673 0.617311 7.78758 0.571149C7.84843 0.524987 7.92272 0.5 7.9991 0.5C8.07548 0.5 8.14977 0.524987 8.21062 0.571149C8.27147 0.617311 8.31556 0.682113 8.33614 0.755668L9.44281 5.05006C9.5053 5.2923 9.63157 5.51338 9.80847 5.69028C9.98537 5.86718 10.2064 5.99344 10.4487 6.05594L14.7431 7.16261C14.8169 7.18298 14.882 7.22701 14.9285 7.28796C14.9749 7.3489 15 7.42339 15 7.5C15 7.5766 14.9749 7.65109 14.9285 7.71204C14.882 7.77299 14.8169 7.81702 14.7431 7.83739L10.4487 8.94406C10.2064 9.00656 9.98537 9.13282 9.80847 9.30972C9.63157 9.48662 9.5053 9.70769 9.44281 9.94994L8.33544 14.2443C8.31486 14.3179 8.27077 14.3827 8.20992 14.4289C8.14907 14.475 8.07478 14.5 7.9984 14.5C7.92202 14.5 7.84773 14.475 7.78688 14.4289C7.72603 14.3827 7.68194 14.3179 7.66136 14.2443L6.55469 9.94994Z"
          fill="#B266FF"
        />
      </svg>
    </Box>
  );
}
